import {
  isSingletonContentSection,
  isOrderedContentSection,
  isGridPositionsContentSection
} from 'zoomforth_codesbane_viewer/lib/sections.js';

import {
  generateSectionId
} from './id_generators.js';

import { DEFAULT_GRID_TAXONOMY } from 'grid_taxonomy.js';


const INITIAL_GRID_COLUMN_COUNT = 3;


export const generateNewSectionData = (sectionType, extraSectionData={}) => {
  const newSection = {
    id: generateSectionId(),
    type: sectionType
  };

  if (isSingletonContentSection(newSection)) {
    newSection.singletonContentUuid = null;
  } else if (isOrderedContentSection(newSection)) {
    newSection.orderedContentUuids = [];
  } else if (isGridPositionsContentSection(newSection)) {
    newSection.gridPositions = [];
    newSection.gridTaxonomy = DEFAULT_GRID_TAXONOMY;
    newSection.columnCount = INITIAL_GRID_COLUMN_COUNT;
  }

  return {
    ...newSection,
    ...extraSectionData
  };
};